import gql from 'graphql-tag'

export const GET_PRICE_POLICY_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
  ) {
    getPricePolicyPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
      }
    ) {
      hasMore
      total
      items {
        id
        currency
        fromPrice
        discount
        clientType
      }
    }
  }
`;

export const GET_PRICE_POLICY_WITH_EXTRA_DATA_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getPricePolicy (
      data: {
        id: $id
      }
    ) {
      id
      currency
      fromPrice
      discount
      clientType
    }
    getAllCurrencies {
      title
    }
  }
`;

export const GET_PRICE_POLICY_EXTRA_DATA_QUERY = gql`
  query {
    getAllCurrencies {
      title
      symbol
      left
    }
  }
`;
